import { DirectionFilter } from './types';
import type { SearchState } from './types';

const isDirectionEmpty = (direction?: DirectionFilter): boolean => {
    return !direction || direction === DirectionFilter.ALL;
};

export const isSearchStateEmpty = ({
    direction,
    includeContainedTransactions,
    replaceBulkTransactions,
    ...searchState
}: Partial<SearchState>): boolean =>
    isDirectionEmpty(direction) &&
    Object.values(searchState)
        .flatMap((value) => (typeof value === 'object' ? Object.values(value) : [value]))
        .filter(Boolean).length === 0;
